export default "__VITE_ASSET__422bc576__"